import { useAuthFetchWithResult } from '@e3dc-react/shell/Hooks/AuthFetch'

import { useTypedSelector } from 'src/State/RootReducer'
import { fetchChargingCards } from './charging-cards.api'
import { ChargingCardModel } from './models/charging-card-model'
import { chargingCardsTransformer } from './transformers/charging-cards-transformer'
import { MOCK_CHARGING_CARDS } from '../../guided-tour/mock-data/mock-charging-cards'
import { useFetchWallboxes, WallboxModel } from '../../wallboxes'
import { usePortalQuery } from 'src/Libs/api'

/**
 * Function for fetching charging cards data
 * @returns charging cards as array of ChargingCardsModel, isLoading as boolean and isError as boolean
 */
interface UseChargingCardsHook {
  chargingCards: ChargingCardModel[]
  wallboxes: WallboxModel[]
  isLoading: boolean
  isError: boolean
  isSuccess: boolean
}
export const useFetchChargingCards = (installationId: number): UseChargingCardsHook => {
  const authFetch = useAuthFetchWithResult()
  const eMobilityTourRunning = useTypedSelector(state => state.eMobility.tour.isRunning)
  const { wallboxes, isLoading: isWallboxesLoading, isError: isWallboxesError, isSuccess: isWallboxesSuccess } = useFetchWallboxes(installationId)

  const {
    data,
    isLoading: isChargingCardsLoading,
    isError: isChargingCardsError,
    isSuccess: isChargingCardsSuccess,
  } = usePortalQuery({
    queryFn: () => (eMobilityTourRunning ? Promise.resolve(MOCK_CHARGING_CARDS) : fetchChargingCards(installationId, authFetch)),
    initialData: eMobilityTourRunning ? MOCK_CHARGING_CARDS : undefined,
    queryKey: ['chargingCards', installationId],
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  })

  const chargingCards = chargingCardsTransformer(data ?? undefined, wallboxes)

  return {
    chargingCards,
    isLoading: isChargingCardsLoading || isWallboxesLoading,
    isError: isChargingCardsError || isWallboxesError,
    isSuccess: isChargingCardsSuccess && isWallboxesSuccess,
    wallboxes,
  }
}
